import React, {Component} from 'react';

export default class Footer extends Component {
    render(){
        return (
            <footer className="main-footer">
                <strong>Copyright &copy; Universitas Multimedia Nusantara</strong>
            </footer>
        )
    }
}